import "../styles/About.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMobileAlt, faDatabase } from '@fortawesome/free-solid-svg-icons'
import { faReact, faNodeJs, faSwift, faAws, faJsSquare, faSquareTumblr, faGoogle } from '@fortawesome/free-brands-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { HiArrowLongRight } from "react-icons/hi2";


export const About = () => {
  return (
    <div className="container spacerx" id="about">
      <div className="col-md-9 mx-auto">

        <div className="row">
          <h4 className="text-secondary decorated" data-aos="fade-up" data-aos-duration="1000">
            <span>Technologies I've been working with recently:</span></h4>

          <div className="col-md-8">
            <p className="mt-3 text-secondary" data-aos="fade-up" data-aos-duration="1000">
              Here are a few technologies I've been working with recently. On the frontend, I build with React, Angular, and Next.js for performant, SEO-optimized web applications, while Swift and React Native with Expo power cross-platform mobile experiences. Apollo Client with GraphQL handles efficient data management and real-time updates across all platforms.
            </p>

            <p className="text-secondary" data-aos="fade-up" data-aos-duration="1200">
              On the backend, I work with Node.js, Express, and Apollo GraphQL Server to develop robust APIs, with TypeScript ensuring reliable, maintainable code. I leverage AWS and Google Cloud Platform for scalable infrastructure, and have been integrating AI workflow automation, RAG (Retrieval-Augmented Generation), and Vector Databases to build intelligent, context-aware applications.</p>


            <div className="row">
              <div className="col">
                <ul className="list-group" data-aos="fade-up" data-aos-duration="1200">
                  <li className="list-group-item"><FontAwesomeIcon icon={faJsSquare} /> React and Angular</li>
                  <li className="list-group-item"><FontAwesomeIcon icon={faNodeJs} /> Node.js</li>
                  <li className="list-group-item"><FontAwesomeIcon icon={faSquareTumblr} /> TypeScript</li>
                </ul>
              </div>
              <div className="col">
                <ul className="list-group list-group" data-aos="fade-up" data-aos-duration="1200">

                  <li className="list-group-item"><FontAwesomeIcon icon={faMobileAlt} /> React Native</li>
                  <li className="list-group-item"><FontAwesomeIcon icon={faSwift} /> Swift</li>
                  <li className="list-group-item"><FontAwesomeIcon icon={faReact} /> Apollo/GraphQL</li>
                </ul>
              </div>

              <div className="col">
                <ul className="list-group list-group" data-aos="fade-up" data-aos-duration="1200">
                  <li className="list-group-item"><FontAwesomeIcon icon={faAws} /> AWS</li>
                  <li className="list-group-item"><FontAwesomeIcon icon={faGoogle} /> Firebase</li>
                  <li className="list-group-item"><FontAwesomeIcon icon={faDatabase} /> SQL/NoSQL/Vector DB</li>

                </ul>
              </div>
            </div>
          </div>

          <div className="col-md-4 text-center">
            <img src={require('../assets/img/erwin_agpasa.png')} alt="me" className="me rounded img-fluid" />
            {/* <small className="mt-3 text-secondary d-block">
              <a href="https://www.paypal.com/donate/?hosted_button_id=83X4VR23JDGK2" className="btn btn-outline-secondary" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faCoffee} /> Buy me a coffee
              </a>
            </small> */}


            <a href="https://github.com/erwinagpasa" target="_blank" rel="noreferrer" className="mt-3 btn btn-coral btn-lg">
              Check out my Github <FontAwesomeIcon icon={faGithub} /></a>

            <a href="https://blog.devph.io" target="_blank" rel="noreferrer" className="mt-3 btn btn-primaryx btn-lg">
              Powerschool Customization <HiArrowLongRight /></a>


          </div>
        </div>
      </div>
    </div>
  )
}